import { ArrowUpRight, Zap } from "lucide-react";
import { ZOOMY } from "@/constants/zoomyIds";

export const Hero = () => {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative pt-32 sm:pt-40 pb-20 sm:pb-28 overflow-hidden tactical-grid">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-lime-400/[0.07] blur-[140px] rounded-full" />

      <div className="max-w-7xl mx-auto px-6 sm:px-10 relative">
        {/* Overline */}
        <div className="reveal flex items-center gap-3 mb-8">
          <span className="inline-block w-2 h-2 bg-lime-400 animate-pulse" />
          <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] text-lime-400">
            EV Mobility · Rental · Dealership · Est. 2025
          </span>
        </div>

        <div className="reveal" style={{ animationDelay: "0.1s" }}>
          <h1 className="font-display font-black text-[2.75rem] leading-[0.92] sm:text-7xl lg:text-[7rem] xl:text-[8.25rem] tracking-tighter max-w-5xl">
            Powering your ride. <br />
            <span className="text-lime-400">Fueling</span> the{" "}
            <span className="lime-underline">future</span>.
          </h1>

          <div className="mt-10 grid lg:grid-cols-12 gap-8 items-start">
            <div className="lg:col-span-7">
              <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
                India&apos;s sharpest electric two-wheeler rental & dealership network.
                <span className="text-white"> Affordable EV bikes, on demand</span> — and a proven
                sales engine ready for scale-up capital.
              </p>
              <p className="mt-3 text-sm sm:text-base text-slate-400 font-medium">
                किफायते पे EV बाईक्स उपलब्ध · रोज़ चलाओ, हर रोज़ बचाओ.
              </p>
            </div>

            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:justify-end gap-3 sm:gap-4">
              <a
                href="#contact"
                onClick={scrollTo("contact")}
                data-testid={ZOOMY.heroRentCta}
                className="btn-lime group inline-flex justify-center items-center gap-3 bg-lime-400 text-black font-bold uppercase tracking-wider text-sm px-7 py-4 hover:bg-lime-300 transition-colors"
              >
                Rent a Zoomy
                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
              <a
                href="#partner"
                onClick={scrollTo("partner")}
                data-testid={ZOOMY.heroPartnerCta}
                className="inline-flex justify-center items-center gap-3 border border-lime-400/70 text-lime-400 font-bold uppercase tracking-wider text-sm px-7 py-4 hover:bg-lime-400 hover:text-black transition-colors"
              >
                Partner with us
                <Zap className="w-4 h-4" strokeWidth={2.5} />
              </a>
            </div>
          </div>

          {/* Trust strip */}
          <div className="mt-16 grid grid-cols-3 border-t border-white/10">
            {[
              { k: "Bikes Sold", v: "50+" },
              { k: "Active Riders", v: "100+" },
              { k: "Uptime", v: "88%" },
            ].map((t, i) => (
              <div
                key={t.k}
                className={`py-6 sm:py-8 ${i > 0 ? "border-l border-white/10 pl-5 sm:pl-8" : ""}`}
              >
                <div className="font-display text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white">
                  {t.v}
                </div>
                <div className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-slate-500 mt-2">
                  {t.k}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
